import React from 'react';
import './WhyChooseUs.css';

function WhyChooseUs() {
  const features = [
    {
      icon: 'shipping',
      title: 'Nation-wide Shipping',
      description: 'Fast, reliable delivery to every corner of the country.'
    },
    {
      icon: 'quality',
      title: 'Exceptional Quality',
      description: 'Handcrafted pieces selected with meticulous attention to detail.'
    },
    {
      icon: 'offers',
      title: 'Fair Pricing',
      description: 'Ethical practices with transparent, competitive pricing.'
    },
    {
      icon: 'secure',
      title: 'Secure & Trusted',
      description: 'Protected transactions with industry-leading security standards.'
    }
  ];

  const renderIcon = (iconType) => {
    const iconMap = {
      shipping: '↗',
      quality: '◆',
      offers: '✓',
      secure: '⚔'
    };
    return iconMap[iconType] || '◆';
  };

  const getLink = (icon) => {
    const links = {
      shipping: '/shipping',
      quality: '/quality',
      offers: '/returns',
      secure: '/payments'
    };
    return links[icon];
  };

  return (
    <section className="why-choose-us">
      <div className="container">
        <h2 className="section-title">Commitment to Excellence</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <a key={index} href={getLink(feature.icon)} className="feature-card">
              <div className={`feature-icon icon-${feature.icon}`}>
                {renderIcon(feature.icon)}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
